import {
    FETCH_ENTITY_SENSORS,
    FETCH_ENTITY_RULES,
    FETCH_INSPECTION_REPORTS,
    FETCH_SENSOR_COUNT_REPORT,
    SET_PROCESS_ID,
    SET_WATCHDOG_REPORTS
} from '../actions/actionTypes';

const initialState = {
    entityRules:       [],
    entityRulesMeta:   {},
    entitySensors:     {},
    inspectionReports: [],
    sensorCountReport: [],
    processId:         '',
    watchDogReports:   []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ENTITY_SENSORS:
            return {
                ...state,
                entitySensors: {...action.payload}
            };
        case FETCH_ENTITY_RULES:
            return {
                ...state,
                entityRules:     [...action.payload.data],
                entityRulesMeta: {...action.payload.meta}
            };
        case FETCH_INSPECTION_REPORTS:
            return {
                ...state,
                inspectionReports: [...action.payload]
            };
        case FETCH_SENSOR_COUNT_REPORT:
            return {
                ...state,
                sensorCountReport: [...action.payload]
            };
        case SET_PROCESS_ID:
            return {
                ...state,
                processId: action.payload
            };
        case SET_WATCHDOG_REPORTS:
            return {
                ...state,
                watchDogReports: [...action.payload]
            };
        default:
            return state;
    }
};
